import { supportedFileExts } from "@/app/components/common-form-builder/common-fields/hook-upload-files/upload-files-helpers/upload";
import SvgAttach from "../consult-form-icons/SvgAttach";

interface Props {
  handleUpload: (files: FileList) => void;
  caption: string;
}

const UploadFiles: React.FC<Props> = ({ handleUpload, caption }) => {
  return (
    <label>
      <input
        type="file"
        style={{ display: "none" }}
        multiple
        onClick={(e) => ((e.target as HTMLInputElement).value = "")}
        accept={supportedFileExts.join(",")}
        onChange={(e) => handleUpload((e.target as HTMLInputElement)?.files!)}
      />
      <div
        className="neutral-btn small-round"
        style={{ height: 32, cursor: "pointer" }}
      >
        <SvgAttach />
        {caption}
      </div>
    </label>
  );
};

export default UploadFiles;
